/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {sendPoolContributionAsync} from '../api'

export const useMutationSendPoolContributionAsync = createReactQueryMutationHook('sendPoolContributionAsync', sendPoolContributionAsync)
